import React from 'react';
import { Loader } from '@fiverr-private/feedback';
import { Container, Stack } from '@fiverr-private/layout_components';
import { theme } from '@fiverr-private/theme';
import { ModalLoaderProps } from '../types';

import { containerStyles } from './styles.ve.css';

const ModalLoader = ({ children, isLoading = false, loaderTestId }: ModalLoaderProps) => (
  <Container overflowY="auto" height="inherit" className={containerStyles}>
    {isLoading && (
      <Stack
        position="absolute"
        top={0}
        left={0}
        bottom={0}
        right={0}
        width="100%"
        height="100%"
        alignItems="center"
        justifyContent="center"
        gap="0"
        data-testid={loaderTestId}
      >
        <Loader />
      </Stack>
    )}
    <Stack
      height="inherit"
      direction="column"
      gap="0"
      visibility={isLoading ? 'hidden' : undefined}
      opacity={isLoading ? '0' : undefined}
      transition={`${theme.animationDuration.fast2} ${theme.animationTiming.easeIn}`}
    >
      {children}
    </Stack>
  </Container>
);

ModalLoader.displayName = 'ModalLoader';

export default ModalLoader;
